import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/app/src/components/ui/breadcrumb/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/app/src/components/user/address/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/app/src/components/user/orders/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/app/src/components/user/security/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/app/src/components/user/side-menu/menu-item.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/app/src/components/user/wishlist/index.js");
